import { YANADOO_CDN_HOST } from 'common/config'

export const levelTestAiStartValues = {
  HOST_CDN: `${YANADOO_CDN_HOST}/levelTestAi/`,
  buttonList: [
    {
      type: 'quiz',
      name: '퀴즈형',
      time: 2,
      checkList: ['공공장소에 있어서 말하기 어려운 분', '간편하고 빠른 테스트를 선호하는 분'],
      image: 'image-start-quiz.png'
    },
    {
      type: 'conversation',
      name: '대화형',
      time: 3,
      checkList: ['나만의 공간에 있어 대화가 가능한 분', '내 실력을 정확히 테스트 해보고 싶은 분'],
      image: 'image-start-conversation.png'
    }
  ],
  featureList: [
    {
      description: `빠르게 진단하고 학습 피드백까지`,
      title: `딱 3분이면 
      내 영어 실력 파악 끝`
    },
    {
      description: `AI 오드리와 통화하듯이`,
      title: `영상 통화처럼 주고받는
      실전형 맞춤 1:1 테스트`
    },
    {
      description: `국제 기준으로 더 정확하게`,
      title: `CEFR 기반 분석부터
      맞춤 학습 방법까지`
    },
    {
      description: `시간 날 때 바로! 내가 원하는 시간에`,
      title: `퇴근 후에도 OK
      언제든 테스트할 수 있어요`
    },
    {
      description: `데이터 기반의 스마트 추천`,
      title: `내 실력에 맞는 수업까지
      AI가 딱 추천`
    },
    {
      description: `한 문제도 놓치지 않도록 꼼꼼하게`,
      title: `모든 문제에 대한
      정답과 해설이 함께 제공`
    }
  ]
}
